<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import estimatedCostPicture from "src/pages/components/planned-cost/search/modules/picture/modules/estimated-cost-picture.vue";
const textAlign = "right";
const labelWidth = 90;

function setList(list) {
  return list.reduce((pre, next) => {
    // console.log(pre);
    const lastIndex = pre.length - 1;
    if (!pre[lastIndex] || (pre[lastIndex] && pre[lastIndex].length >= 6 * 3)) {
      pre.push([]);
    }
    pre[pre.length - 1].push(next);
    return pre;
  }, []);
}
@Component({
  components: { estimatedCostPicture }
})
export default class App extends Vue {
  list = [];
  showList = []
  isLoading = false;
  params = {};
  pageConfig = {
    pageSize: 100,
    pageNumber: 1,
    total: null
  };
  POST_BOM_COSTCHECK_VIEW_PAGE() {
    return new Promise((resolve, reject) => {
      this.$apis.autoAPi
        .POST_BOM_COSTCHECK_VIEW_PAGE({
          ...this.params,
          ...this.pageConfig
        })
        .done(res => {
          // const list = setList(res.list);
          this.pageConfig.total = res.totalCount;
          resolve(res.data);
        })
        .fail(err => {
          reject([]);
        });
    });
  }
  mounted() {
    const { type } = this.$route.query;
    this.pageType = type;
    try {
      this.params = JSON.parse(
        window.localStorage.getItem("maintenance/plannedCost/search/picture")
      );
    } catch (e) {
      this.params = {
        pageSize: 10,
        pageNumber: 1
      };
    }
    this.isLoading = true;
    const that = this;
    this.$emit("handleIsLoading", true);
    getAllList()
      .then(res => {
        console.log("over");
        that.$emit("handleIsLoading", false);
      })
      .catch(err => {
        console.log("catch");
      });
    function getAllList() {
      // if (
      //   that.pageConfig.total !== null &&
      //   that.list.total >= that.pageConfig.total
      // )
      //   return Promise.resolve();
      return that
        .POST_BOM_COSTCHECK_VIEW_PAGE()
        .then(list => {
          if (list.length === 0) {
            that.showList = setList(that.list)
            return Promise.resolve()
          } else {
            that.list = that.list.concat(list);
            that.pageConfig.pageNumber = that.pageConfig.pageNumber + 1;
            return getAllList();
          }
        })
        .catch(err => {
          that.isLoading = false;
        });
    }
  }
  render(h) {
    return (
      <div class="maintenance-picture-print">
        {this.showList.map((item, $index) => {
          return (
            <div class="maintenance-picture-print__page">
              {item.map(inner => {
                return (
                  <estimated-cost-picture info={inner}></estimated-cost-picture>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  }
}
</script>

<style lang="scss">
@media print {
  .maintenance-picture-print__page {
    page-break-inside: avoid !important;
    page-break-before: unset !important;
    -webkit-print-color-adjust: exact;
    width: calc(365px * 6);
  }
}
.maintenance-picture-print__page {
  width: calc(365px * 6);
  page-break-inside: avoid !important;
    page-break-before: unset !important;
  display: flex;
  flex-wrap: wrap;
}
.maintenance-picture-print {
  background: #fff;
}
</style>
